import { Col, Layout, Row } from "antd";
import React, { useState } from "react";
import themeConfig from "../configs/themeConfig";
import MenuFooter from "./components/footer";
import HeaderHorizontal from "./components/header/HeaderHorizontal";
import ScrollTop from "./components/scroll-to-top";

const { Content } = Layout;

export default function HorizontalLayout(props) {
    const { children } = props;
    const [visible, setVisible] = useState(false);

    return (
        <Layout className={`hp-app-layout hp-bg-color-dark-90 ${themeConfig.navigationBg && 'hp-app-layout-bg'}`}>
            <HeaderHorizontal visible={visible} setVisible={setVisible} />

            <Content className="hp-content-main">
                <Row justify="center">
                    {
                        themeConfig.contentWidth == "full" && (
                            <Col span={24}>
                                {children}
                            </Col>
                        )
                    }

                    {
                        themeConfig.contentWidth == "boxed" && (
                            <Col xxl={20} xl={22} span={24}>
                                {children}
                            </Col>
                        )
                    }
                </Row>
            </Content>

            <MenuFooter />

            <ScrollTop />
        </Layout>
    );
};